import { useEffect, useState } from "react";
import Button from "../UI/Button";
import { useDispatch } from "react-redux";
import { RootState } from "../../redux/type";
import { sendMessage, sendPrivacyPolicy } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { title } from "process";

var storageRef = firebase.storage().ref();

export default function EditPrivacyPolicy() {
  const [messages, setMessages] = useState({ description: "",});
  const [success, setSuccess] = useState(""); // to display message if the message is sent or not
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  //getting newsletter data from firebase
  useEffect(() => {
    const fetchPrivacyPolicyData = async () => {
      try {
        const db = firebase.firestore();

        const privacyPolicyDoc = await db.collection('Game_Config').doc("PrivacyPolicy").get()
        const privacyPolicyData = privacyPolicyDoc.data()
        console.log("privacyPolicyData data", privacyPolicyData)
        if (privacyPolicyData) {
          setMessages({
            description: privacyPolicyData?.Description || ""
          });
        } else {
          console.log("No such privacyPolicyData document!");
        }
      } catch (error) {
        console.error("Error fetching document: ", error);
      }
    };

    fetchPrivacyPolicyData();
  }, []);
  
  const getMessages = (e: any) => {
    setMessages((prevMessages) => ({
      ...prevMessages,
      [e.target.name]: e.target.value,
    }));
    console.log("get msg, msg data is", messages);
  };

  //submitting form data here and sending
  const saveMessage = async (e: any) => {
    e.preventDefault();
    const { description } = e.target;
    let isValid: boolean = true;
    console.log("save msg, msd datda before", messages);

    if (
      description.value.trim() === ""
    ) {
      setError("Please select Description correctly");
      setSuccess("");
      isValid = false;
    }
    if( description.value.trim().length <= 10){
      setError("Make sure that, title has more than 10 and less than 30 characters, description has more than 10 characters");
      setSuccess("");
      isValid=false
    }
    if(isValid){
      const currentDate = new Date()
      const messageData = { ...messages, updatedAt : currentDate.toISOString().split("T")[0]};

      console.log("messages is", messageData)
      dispatch(sendPrivacyPolicy(messageData))
      setError("");
      setSuccess("Privacy policy updated successfully");

    }
}

  return (
    <main>
      <div className="container-fluid px-4">
        <div>
          <h1>Update Privacy Policy</h1>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={saveMessage}>
              <div className="form-row">
                Description
                <textarea
                  className="form-control"
                  style={{ lineHeight: "normal", padding: "1.5%", color:"black" }}
                  id=""
                  value={messages.description}
                  name="description"
                  onChange={getMessages}
                ></textarea>
              </div>

              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}

              <Button text="Submit Privacy Policy" className="btn btn-primary btn-lg" />
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
